import React from "react";
var __jsx = React.createElement;
import { apiUrl, apiUrlInternal, BUILD_VERSION, SELECTED_ENV, serverUrl, SHOW_DEBUG_INFO } from "@globalConfig";
import { useTranslation } from "@i18n";
import { cn } from "@/common/lib/utils";

/**
 * Build version + env/API readout that QA relies on, carried over from the
 * retired `NewAside`. Shared by the responsive side menu and the desktop
 * account dropdown so the two cannot drift apart.
 *
 * Gating matches the old aside exactly: the version line shows wherever
 * `BUILD_VERSION` is set (production included), the env/API block only under
 * `SHOW_DEBUG_INFO` (CSR-only, local/qa/dev/dev2/preprod). Callers that must
 * not grow in production — the desktop dropdown — wrap this in their own
 * `SHOW_DEBUG_INFO` check. `.buildVer` in the aside was 12px / width 100% /
 * margin-top 20px / `var(--lightGray)`.
 */
var BuildInfo = function BuildInfo(_ref) {
  var className = _ref.className;
  var _useTranslation = useTranslation(["web_aside_menu"]),
    t = _useTranslation.t;
  if (!BUILD_VERSION && !SHOW_DEBUG_INFO) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: cn("w-full text-xs text-[var(--lightGray)]", className)
  }, BUILD_VERSION && /*#__PURE__*/React.createElement("div", {
    id: "build-version"
  }, /*#__PURE__*/React.createElement("span", null, t("version", {
    ns: "web_aside_menu"
  }), ": ", /*#__PURE__*/React.createElement("strong", null, BUILD_VERSION))), SHOW_DEBUG_INFO && /*#__PURE__*/React.createElement("div", {
    className: "mt-5 [overflow-wrap:anywhere]",
    style: {
      direction: "ltr"
    }
  }, /*#__PURE__*/React.createElement("p", null, "ENV: ", /*#__PURE__*/React.createElement("strong", null, SELECTED_ENV)), /*#__PURE__*/React.createElement("p", null, "API: ", /*#__PURE__*/React.createElement("strong", null, apiUrl)), /*#__PURE__*/React.createElement("p", null, "Internal API: ", /*#__PURE__*/React.createElement("strong", null, apiUrlInternal)), /*#__PURE__*/React.createElement("p", null, "Server URL: ", /*#__PURE__*/React.createElement("strong", null, serverUrl))));
};
export default BuildInfo;